import {CANONICAL_LINK_REGEXP, REGION_KEYS} from 'assets/js/constants'
import {I18nHeadMetaInfo} from 'vue-i18n-routing'

export const useCanonicalPathHelper = () => {
  const adjustCanonicalPath = (currentPath: string, i18nHead: I18nHeadMetaInfo) => {
    const canonicalPath = currentPath.match(CANONICAL_LINK_REGEXP)

    if (Array.isArray(canonicalPath) && canonicalPath.length === 3) {
      const newPath = `/${REGION_KEYS.GLOBAL.toLowerCase()}/${canonicalPath[2]}`
      const canonicalLink = i18nHead.link?.find(link => link.rel === 'canonical')

      if (canonicalLink?.href) {
        const url = new URL(canonicalLink.href)
        url.pathname = newPath
        canonicalLink.href = url.toString()
      }
    }
  }

  return {
    adjustCanonicalPath
  }
}
